import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { GetSymptomsFromImmediatePastVisitType } from 'types/patients';

const initialState: GetSymptomsFromImmediatePastVisitType | null = {
  firstName: 'Jennifer',
  lastName: 'Capriati',
  attributes: ['Redness', 'Discoloration'],
};

export const symptomsSlice = createSlice({
  name: 'symptoms',
  initialState,
  reducers: {
    symptomsAction: (state, action: PayloadAction<any>) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { symptomsAction } = symptomsSlice.actions;

export default symptomsSlice.reducer;
